export default class BatchMessageCostRequestModel {
	public preSubmissionConfigurationId: string;
	public groups: Group[];
	public totalCost: number;
	public partitionKey: string;

	public constructor() {
		this.preSubmissionConfigurationId = "";
		this.groups = [];
		this.totalCost = 0;
		this.partitionKey = "";
	}
}

export class Group {
	public id: string;
	public messageCosts: MessageCost[];
	public costPerGroup: number;

	public constructor() {
		this.id = "";
		this.messageCosts = [];
		this.costPerGroup = 0;
	}
}

export class MessageCost {
	public id: string;
	public title: string;
	public length: number;
	public cost: number;

	public constructor() {
		this.id = "";
		this.title = "";
		this.length = 0;
		this.cost = 0;
	}
}
